import { defineMessage } from 'services/localization';

export const messages = {
    lastStep: defineMessage('last_step'),
    title: defineMessage('connect_your_accounting_system'),
    description1: defineMessage('connecting_the_accounti_stem_allows_you_to_test'),
    description2: defineMessage('all_the_features_within_your_trial'),
};
